import { Heading } from '@spark-web/heading';
import { ContentDialog } from '@spark-web/modal-dialog';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

import { Button as BrighteButton } from '~/components/common/button';
import { Footer } from '~/components/footer';
import { AnalyticsEvents } from '~/constants/analytics';
import { useModal } from '~/hooks/useModal';
import { useAnalyticsContext } from '~/provider/AnalyticsProvider';

type LandingInformationProps = {
  onGetStarted: () => void;
};

export const LandingInformation = ({ onGetStarted }: LandingInformationProps) => {
  const { onCloseAutoFocus, isOpen } = useModal('landing-information');
  const { track } = useAnalyticsContext();

  const onGetStartedClick = () => {
    onGetStarted();
    track(AnalyticsEvents.LandingGetStartedClicked);
  };

  return (
    <ContentDialog isOpen={isOpen} onToggle={() => {}} onCloseAutoFocus={onCloseAutoFocus}>
      <Stack gap="xxlarge">
        <Heading level="2">Great! First vendor added.</Heading>
        <Stack gap="xlarge">
          <Text>{"Compare up to 3 vendors and we'll help you pick the best fit"}</Text>

          <BrighteButton rounded type="button" onClick={onGetStartedClick}>
            Save my selection
          </BrighteButton>
          <Footer />
        </Stack>
      </Stack>
    </ContentDialog>
  );
};
